// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".truncate[data-v-0144ab9c]{-o-line-clamp:1;-ms-line-clamp:1;-webkit-line-clamp:1}.todo-selected[data-v-0144ab9c]{border-color:var(--lms-tenant)!important}.deadline-passed[data-v-0144ab9c]{border-color:red}", ""]);
// Exports
module.exports = exports;
